import ApiRoutes from "../../../constants/api-routes";
import { hneWarehouseAPI } from "../../../service";

export const getConnections = async () =>
  hneWarehouseAPI.get(`${ApiRoutes.GET_CONNECTIONS}`);

export const checkMySQLConnection = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.CHECK_MYSQL_CONNECTION}`, body);

export const checkMongoDBConnection = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.CHECK_MONGODB_CONNECTION}`, body);

export const getTables = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.GET_TABLES}`, body);

export const getDatabases = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.GET_DATABASES}`, body);

export const createBackup = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.CREATE_BACKUP}`, body);

export const createBackupFull = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.CREATE_BACKUP_FULL}`, body);

export const getBackupProgress = async (backupId) =>
  hneWarehouseAPI.get(`${ApiRoutes.GET_BACKUP_PROGRESS}/${backupId}`);

export const getBackups = async (dbType) =>
  hneWarehouseAPI.get(`${ApiRoutes.GET_BACKUPS}/${dbType}`);

export const restoreBackupFile = async (body) =>
  hneWarehouseAPI.post(`${ApiRoutes.RESTORE_BACKUP}`, body);

export const getRestoreProgress = async (restoreId) =>
  hneWarehouseAPI.get(`${ApiRoutes.GET_RESTORE_PROGRESS}/${restoreId}`);
